import { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { cn } from '@/lib/utils';

export function OfflineIndicator() {
  const { language } = useLanguage();
  const isOnline = useOnlineStatus();
  const [showBanner, setShowBanner] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShowBanner(true);
      setWasOffline(true);
    } else if (wasOffline) {
      // Keep banner visible briefly to show "back online" message
      const timer = setTimeout(() => {
        setShowBanner(false);
        setWasOffline(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline]);

  if (!showBanner) return null;

  return (
    <div 
      className={cn(
        "fixed top-0 left-0 right-0 z-[60] py-2 px-4 text-center text-sm font-medium flex items-center justify-center gap-2 transition-colors",
        isOnline 
          ? "bg-green-500/90 text-white" 
          : "bg-destructive text-destructive-foreground"
      )}
    >
      {!isOnline && <WifiOff className="w-4 h-4" />}
      {isOnline 
        ? (language === 'sv' ? 'Ansluten igen' : 'Back online')
        : (language === 'sv' ? 'Du är offline' : "You're offline")
      }
    </div>
  );
}
